import React from 'react'

const FloatingLabelTextInput = ({ label, value, onChangeHandler, disabled }) => {
  return (
    
    <div id="float-label">
      <input
        className='form-control form-control-lg bg-transparent text-white'
        type="text"
        value={value}
        onChange={onChangeHandler}
        disabled={disabled}
      />
      <label htmlFor="text" className={value !== '' ? 'Active' : ''}>{label}</label>
      <br />
    </div>
    
  )
}

export default FloatingLabelTextInput